export default __webpack_public_path__ + "static/media/card-2.ab99aff7.webp";